import React from "react";
import { ApplyRecipeSvg } from "assets/icons/ApplyRecipeSvg";
import { Button } from "react-bootstrap";
import { NO_RECIPES_APPLIED } from "configurations/MessageConstants";
import { useSelector } from "react-redux";

const EmptyRecipeUsage = ({ onAddRecipeUsage }) => {
  const selectedSite = useSelector((state) => state.site.selectedSite);
  const isSharedViewOnly = selectedSite.isShared && !selectedSite.editor;
  return (
    <div className="text-center d-flex flex-column align-items-center my-2">
      <ApplyRecipeSvg />
      <span className="text-muted my-2">{NO_RECIPES_APPLIED}</span>
      {!isSharedViewOnly && (
        <Button
          variant="outline-dark"
          size="sm"
          className="rounded-pill"
          onClick={onAddRecipeUsage}
        >
          <i className="fa fa-circle-plus me-1"></i>
          Apply Recipe
        </Button>
      )}
    </div>
  );
};

export default EmptyRecipeUsage;
